export const FINANCING = 'Financing';

export const AUTO = 'Auto';
export const HOME = 'Home';

export const MORTGAGE = 'Mortgage';

export const LOAN_TYPE = {
  [AUTO]: AUTO,
  [HOME]: MORTGAGE,
};

export const DOWN_PAYMENT = 'Down Payment';
export const TRADE_IN_VALUE = 'Trade In Value';

export const SELECTED = 'selected';
export const NOT_SELECTED = 'not-selected';

export const RESET_ALL = 'Reset All';
export const CHECK_RATES = 'Check Rates';
export const APPLY_CHANGES = 'Apply Changes';

export const TEXT = 'text';

// fieldTypes
export const SELECT = 'select';
export const INPUT = 'input';
export const INCOME_TEXT = 'income_text';
export const ASSET_TEXT = 'asset_text';
export const LIABILITY_TEXT = 'liability_text';
export const NET_WORTH_TEXT = 'net_worth_text';
export const NET_WORTH_TEXT_ROW = 'net_worth_text_row';

export const TABS = 'Tabs';

export const NET_WORTH_ASSET_TEXT = 'net_worth_asset_text';
export const NET_WORTH_LIABILITY_TEXT = 'net_worth_liability_text';

export const NUMBER = 'number';

export const CANCEL = 'Cancel';
export const CONFIRM = 'Confirm';

// Modal Content Page
export const FULL_WIDTH = 'full-width';
export const DOUBLE_FIELDS_WRAPPER = 'double-fields-wrapper';
export const SINGLE_FIELD_WRAPPER = 'single-field-wrapper';

export const state_rates_filter = 'state';
export const zip_code_rates_filter = 'zip_code';
